import { wgDomains2 } from "@/components/common/GoogleAd1/config1";
import { getHashFromUrl } from "@/utils";
import { isShowNews1 } from "@/utils/isShowNews1";
import { nanoid } from "nanoid";
import classNames from "classnames";
import { isAddBgColorAtom } from "@/atoms/app";
import { miQsWeatherDomains } from "@/constants/domain.config";
import { getCurrentAdScenario } from "@/hooks/useAdScenario";

export function useAdCpt(): JSX.Element | null {
  const isAddBgColor = useAtomValue(isAddBgColorAtom);
  const [refreshId, setRefreshId] = useState(nanoid(8));
  const { hostName, domain } = useHostName();
  const { isTranTabAdScenario } = getCurrentAdScenario();
  const hash = getHashFromUrl();
  useEffect(() => {
    setRefreshId(nanoid(8));
  }, [hash]);
  const BASIC_HOME_ROUTES = ["#/", "#/home"];
  const EXTENDED_HOME_ROUTES = ["#/", "#/home", "#/hourly", "#/daily", "#/sun-moon"];
  if ([...domainMap["wg"]].includes(hostName) && ![...wgDomains1, ...wgDomains2, ...wgDomains3].includes(hostName)) {
    return null;
  }
  let adType = 1;
  if ([...domainMap["wi"], ...domainMap["miwg"], ...wgDomains3].includes(hostName)) {
    adType = 2;
  }
  if ([...wgDomains2].includes(hostName) && BASIC_HOME_ROUTES.includes(hash)) {
    adType = 2;
  }
  if ([...wgDomains1].includes(hostName) && EXTENDED_HOME_ROUTES.includes(hash)) {
    adType = 2;
  }
  if ([...wgDomains2].includes(hostName) && !BASIC_HOME_ROUTES.includes(hash)) {
    return null;
  }
  if ([...wgDomains1].includes(hostName) && !EXTENDED_HOME_ROUTES.includes(hash)) {
    return null;
  }
  if (dexLinks.includes(domain)) {
    return (
      <div className="footer-fixed-floorAd">
        <div data-position={"position-01"}>
          <YanDexAd key={refreshId} dataPosition={"position-01"} {...useYanDex("floorAd", 0)} />
        </div>
      </div>
    );
  }
  if (milsDomain1.includes(hostName)) {
    return (
      <div className="footer-fixed-floorAd">
        <div data-position={"position-01"}>
          <GoogleAd1 key={refreshId} dataPosition={"position-01"} {...useGoogleAd1("floorAd", 0)} />
        </div>
      </div>
    );
  }
  const AdComponent = isShowNews1().validMain ? GoogleAd2 : GoogleAd1;
  const adProps = isShowNews1().validMain ? (useGoogleAd2("ad1", 1) ?? {}) : (useGoogleAd1("ad1", adType) ?? {});

  let additionalClass = "";
  if (adProps.type === "ads") {
    additionalClass = "footer-fixed-ads";
  } else if (adProps.type === "adx") {
    additionalClass = "footer-fixed-adx";
  } else if (adProps.type === "dex") {
    additionalClass = "footer-fixed-dex";
  } else if (adProps.type === "floorAd") {
    additionalClass = "footer-fixed-floorAd";
  } else if (adProps.type === "anchor") {
    additionalClass = "footer-fixed-anchor";
  }

  /**
   * 说明：
   * `www + tran_ls_tab` 虽然广告配置复用 tr-tab，但 host 仍是 www。
   * 底部位如果继续按 www 的普通流式容器渲染，就不会是需求里的悬浮底部广告。
   */
  const shouldRenderInlineFloorAd =
    !isTranTabAdScenario &&
    ((([...wgDomains1, ...miwgDomain1, ...domainMap["mils"], ...wgDomains3, ...wwwDomain1].includes(hostName) &&
      !isShowNews1().isValidDismoreChannel) ||
      isShowNews1().isValidDisnewsChannel ||
      miQsWeatherDomains.includes(hostName)));

  const containerClass = `${
    shouldRenderInlineFloorAd ? "center" : "fixed bottom-0 left-0 w-full flex flex-col justify-end items-center"
  } ${additionalClass}`.trim();

  return (
    <div className={containerClass}>
      <div
        data-position={"position-01"}
        className={classNames([
          "w-full",
          /**
           * 说明：
           * tran 底部广告会在 wrapper 顶部预留关闭按钮空间。
           * 这里如果继续给父层铺白底，会把这段预留区域渲染成额外白条，
           * 看起来就会比中部广告多出一块白色背景。
           */
          isAddBgColor && !isTranTabAdScenario && "bg-[var(--app-bg-01)]",
        ])}
      >
        <AdComponent
          key={refreshId}
          dataPosition={"position-01"}
          {...adProps}
          {...(isTranTabAdScenario || miQsWeatherDomains.includes(hostName) ? { isLazyLoad: false } : {})}
        />
      </div>
    </div>
  );
}
